import React, { useState, useEffect } from 'react';
 import { IonButton } from '@ionic/react';
import getApi from '../api';
 
 interface CountdownButtonProps {
   pumpId: string;
   token: string;
 }
 
 const CountdownButton: React.FC<CountdownButtonProps> = ({ pumpId, token }) => {
   const [countdown, setCountdown] = useState(0);
   const [isDisabled, setIsDisabled] = useState(false);
  const api = getApi();
 
   useEffect(() => {
     if (countdown > 0) {
       const timer = setTimeout(() => {
         setCountdown(countdown - 1);
       }, 1000);
 
       return () => clearTimeout(timer);
     } else {
       setIsDisabled(false);
     }
   }, [countdown]);
 
   function sendCommand(command: string, pumpID: string) {
     console.log("Sending command: "+command+" to pump: "+pumpID);
     const data = new FormData();
     data.append('pID', pumpID);
     data.append('cID', command);
     api.post("/bbe/send/", data, {
       headers: {'Content-Type': 'multipart/form-data'}
     })
     .then((res) => {
       console.log(res);
     })
   }
 
   const handleClick = () => {
     sendCommand('17', pumpId);
     setCountdown(120);
     setIsDisabled(true);
   };
 
   return (
     <IonButton
           onClick={handleClick}
           disabled={isDisabled} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}     >
       {isDisabled ? `Väntar: ${countdown}s` : 'Hämta livedata'}
     </IonButton>
   );
 };
 
 export default CountdownButton;